import type { Page } from '$app/state';
import { v4 as uuid } from 'uuid';
import type Stripe from 'stripe';
import { prettyDate } from '~/utils/dates';

export const isUUID = (s: string) =>
  !!s.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/);

export const getCookie = (name: string): string | undefined => {
  for (const pair of document.cookie.split(';')) {
    const eq = pair.indexOf('=');
    if (eq === -1 || pair.slice(0, eq).trim() !== name) continue;
    const value = pair.slice(eq + 1).trim();
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  }
};

export const getUserId = () => {
  let userId = getCookie('userId') ?? localStorage.getItem('userId');
  if (!userId) {
    userId = uuid();
    localStorage.setItem('userId', userId);
  }
  document.cookie = `userId=${encodeURIComponent(userId)}; Path=/; Expires=${new Date('2038-01-19T04:14:07').toUTCString()}; SameSite=Lax`;
  return userId;
};

export const getApiUserId = (page: Page) => page.data.user?.id;

export const validateEmail = (email: string) => {
  const isValid = (/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(email);
  if (!isValid) {
    return 'Please provide a valid email';
  } else {
    return;
  }
};

const PARAMS = ['date', 'mode', 'key'];

export const filterParams = (
  params: Record<string, string | null | false | undefined>,
): Record<string, string> =>
  Object.fromEntries(
    Object.entries(params)
      .filter(([k, v]) => v != null && v !== false && PARAMS.includes(k))
      .sort((a, b) => a[0].localeCompare(b[0])),
  ) as Record<string, string>;

export const getTrialText = (sub: Stripe.Subscription) => `
  You are in a trial period. After your trial ends, you will be charged $${(
    (sub.items.data[0].price.unit_amount ?? 0) / 100
  ).toFixed(2)}
  per
  ${sub.items.data[0].price.recurring?.interval}
  starting
  ${prettyDate(new Date(sub.trial_end! * 1000).toISOString())}. You can always
  cancel before then.
`;
